"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPricingModal = void 0;
const React = __importStar(require("react"));
const Modal_1 = require("../../modal/Modal");
const Button_1 = require("../../button/Button");
const IntroPage_1 = require("./IntroPage");
const MinPriceAndPreview_1 = require("./MinPriceAndPreview");
const MinStay_1 = require("./MinStay");
const ArrivalDays_1 = require("./ArrivalDays");
const Discounts_1 = require("./Discounts");
const Result_1 = require("./Result");
const validation_1 = require("../../../pages/tasks/pricing/validation");
const api_1 = __importDefault(require("../../../../api"));
const helpers_1 = require("../../../../entities/pricing/helpers");
const react_router_dom_1 = require("react-router-dom");
const fullStory_1 = require("../../../../util/fullStory");
const index_1 = require("../../../../index");
const modalPages = [
    IntroPage_1.IntroPage,
    MinPriceAndPreview_1.MinPriceAndPreview,
    MinStay_1.MinStay,
    ArrivalDays_1.ArrivalDays,
    Discounts_1.Discounts,
    Result_1.Result,
];
const initialDefaults = (currency) => ({
    currency,
    min_price: 0,
    min_stay: 1,
    // all days allowed
    checkin_days: Object.keys((0, helpers_1.allDaysAllowed)()),
    discounts: [],
});
const SmartPricingModal = (props) => {
    if (!props.isOpen)
        return null;
    const { appMode } = React.useContext(index_1.AppContext);
    const [currentPage, setCurrentPage] = React.useState(0);
    const [defaults, setDefaults] = React.useState(initialDefaults(props.currency));
    const [validation, setValidation] = React.useState((0, validation_1.validatePricingDefaults)(defaults));
    const [showValidation, setShowValidation] = React.useState(false);
    const [success, setSuccess] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const buildModalButtons = (page, next, prev, onPublish, onClose, onCloseSuccess) => {
        const previousButton = React.createElement(Button_1.Button, { onClick: prev }, "Previous");
        const nextButton = (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Next"));
        if (loading) {
            // show no navigation buttons buttons while loading
            return {};
        }
        else {
            if (page === 0) {
                return {
                    actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Get started")),
                };
            }
            else if (page === modalPages.length - 2) {
                return {
                    actionLHS: React.createElement(Button_1.Button, { onClick: prev }, "Previous"),
                    actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: onPublish }, "Publish prices")),
                };
            }
            else if (page === modalPages.length - 1) {
                return {
                    actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: success ? onCloseSuccess : onClose }, success ? 'View Prices' : 'Ok')),
                };
            }
            else {
                return { actionLHS: previousButton, actionRHS: nextButton };
            }
        }
    };
    // Create defaults row in pricing DB with the currency of the property on component mount.
    // Without this, first time opt ins will always fail to retrieve smart pricing.
    React.useEffect(() => {
        props.updateDefaults(defaults);
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_opt_in_journey_launched', {
            property_id: props.propertyId,
        });
    }, []);
    React.useEffect(() => {
        setValidation((0, validation_1.validatePricingDefaults)(defaults));
    }, [defaults]);
    const onNextPageClick = () => {
        setShowValidation(true);
        if (currentPage === 1) {
            if (!validation.min_price) {
                console.warn('Cannot proceed with invalid data');
                return;
            }
        }
        if (currentPage === 3) {
            if (!Object.keys(validation).every((k) => validation[k])) {
                console.warn('Cannot proceed with invalid data');
                return;
            }
        }
        if (currentPage !== modalPages.length) {
            setCurrentPage(currentPage + 1);
            setShowValidation(false);
        }
    };
    const onPreviousPageClick = () => {
        if (currentPage !== modalPages.length) {
            setCurrentPage(currentPage - 1);
            setShowValidation(false);
        }
    };
    const buttons = buildModalButtons(currentPage, onNextPageClick, onPreviousPageClick, 
    // onPublish
    () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            setCurrentPage(currentPage + 1);
            yield api_1.default.smartPricing.syncPrices(props.propertyId);
            props.updateDefaults(defaults);
            props.updatePricingType({
                type: 'automatic',
                automatic_rate: props.experimentSyncRate,
            });
            setLoading(false);
            setSuccess(true);
            (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_opt_in_journey_complete', { property_id: props.propertyId });
        }
        catch (_a) {
            setLoading(false);
            setSuccess(false);
            (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_opt_in_failure', {
                property_id: props.propertyId,
            });
        }
        setShowValidation(false);
    }), 
    // onClose
    () => {
        props.onClose();
    }, 
    // onCloseSuccess
    () => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_opt_in_view_prices_selected', { property_id: props.propertyId });
        navigate(`/property/${props.propertyId}/${appMode}/tasks/availability`);
    });
    return (React.createElement(Modal_1.Modal, Object.assign({ title: "Smart Pricing", onRequestClose: props.onClose }, buttons), React.createElement(modalPages[currentPage], {
        defaults,
        setDefaults,
        validation,
        showValidation,
        setShowValidation,
        loading,
        success,
    })));
};
exports.SmartPricingModal = SmartPricingModal;
//# sourceMappingURL=SmartPricingModal.js.map